import axios from "axios";
import Banner from "../Components/Banner";
import LoaderImage from "../Assets/images/loader.gif";
import ProductContainer from "../Components/Products/ProductContainer";
import FeedbackContainer from "../Components/Feedback/FeedbackContainer";

import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Stack,
  useTheme,
  Typography,
  useMediaQuery,
  CardActionArea,
  Card,
  Container, // 👈 Container ko import karna zaroori hai
} from "@mui/material";
import API from "../utils/API";
import BrandContainer from "../Components/Brands/BrandContainer";
import { Helmet } from "react-helmet";

function HomePage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const isMatch = useMediaQuery(theme.breakpoints.down("md"));

  const [company, setCompany] = useState({});
  const [meta, setMeta] = useState({});
  const [banners, setBanners] = useState([]);
  const [type, setType] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [brands, setBrands] = useState([]);
  const [isLoading, SetLoading] = useState(false);

  useEffect(() => {
    loadCompanyData();
    loadHomePageMeta();
    loadProducts();
    loadFeedbacks();
    loadBrands();
  }, []);

  const loadCompanyData = async () => {
    try {
      const res = await API({
        method: "GET",
        url: "company_profile",
      });
      setCompany(res[0]);
    } catch (error) {
      console.error("Error loading company data:", error);
    }
  };

  const loadHomePageMeta = async () => {
    try {
      const res = await API({
        method: "GET",
        url: "home_meta",
      });
      setMeta(res[0]);
    } catch (error) {
      console.error("Error loading homepage meta:", error);
    }
  };

  const loadProducts = async () => {
    const res = await API({
      method: "GET",
      url: "slider",
    });
    setBanners(res);
    const typeRes = await API({
      method: "GET",
      url: "type",
    });
    typeRes.map(async (item, index) => {
      const productRes = await API({
        method: "GET",
        url: `product?type=${item.id}`,
      });
      setType((prev) => [
        ...prev,
        { id: item.id, name: item.name, data: productRes.results },
      ]);
    });

    SetLoading(true);
  };

  const loadFeedbacks = async () => {
    const res = await API({
      method: "GET",
      url: "feedback",
    });
    setFeedbacks(res);
  };

  const loadBrands = async () => {
    const res = await API({
      method: "GET",
      url: "brand_slug",
    });
    setBrands(res.filter((item) => item.web === true));
  };

  // 🚀 Helper function with MINIMUM SPACING and DEFAULT COLOR HEADINGS
  const renderHomeDescription = () => {
    const description = company?.description;

    if (!description || description.trim().length === 0) {
      return null;
    }

    return (
      // Container sides se gap aur centering dega (Brand Page jaisa)
      <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}> 
        <Box 
          dangerouslySetInnerHTML={{ __html: description }}
          // Styles for typography within the description
          sx={{
            px: { xs: 2, md: 0 }, 
            
            // Headings ke styles
            '& h1, & h2, & h3, & h4, & h5, & h6': {
              mt: 0.5, // Minimum Margin Top
              mb: 0.5, // Minimum Margin Bottom
              color: '#000000', // ✅ Color set to default (Black/Inherit)
              fontWeight: 700,
            },
            // Paragraphs ke styles
            '& p': {
              mb: 0.5, // ✅ Margin Bottom aur kam karke 0.5 kar diya
              lineHeight: 1.6, 
              fontSize: { xs: '0.9rem', sm: '1rem' } 
            },
            '& a': {
              color: '#000000', 
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }
          }}
        />
      </Container>
    );
  };


  console.log(meta);

  return (
    <>
      <Helmet>
        <title>{meta?.title || "NMP Pharmacy"}</title>
        <meta
          name="description"
          content={meta?.description || "Welcome to NMP Pharmacy"}
        />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <div>
        {isLoading ? (
          <div>
            <Banner banners={banners} />
            <Box sx={{ m: 2 }}>
              {type
                ?.sort((a, b) => a.id - b.id)
                ?.map((item, index) => {
                  if (index === type.length - 2) {
                    return (
                      <>
                        {company.image1 && (
                          <Box sx={{ my: 2 }}>
                            <img
                              src={company.image1}
                              alt="Banner 1"
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                marginTop: "20px",
                                borderRadius: "12px",
                              }}
                            />
                          </Box>
                        )}
                        
                        <ProductContainer
                          key={index}
                          heading={item.name}
                          products={item.data}
                        />
                      </>
                    );
                  }
                  if (index === type.length - 1) {
                    return (
                      <>
                        {company.image2 && (
                          <Box sx={{ my: 2 }}>
                            <img
                              src={company.image2}
                              alt="Banner 2"
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                marginTop: "20px",
                                borderRadius: "12px",
                              }}
                            />
                          </Box>
                        )}

                        <ProductContainer
                          key={index}
                          heading={item.name}
                          products={item.data}
                        />
                      </>
                    );
                  }
                  return (
                    <ProductContainer
                      key={index}
                      heading={item.name}
                      products={item.data}
                    />
                  );
                })}
              {brands.length > 0 && (
                <BrandContainer heading={"Brands"} brands={brands} />
              )}
              {feedbacks.filter((item) => item.active === true).length > 0 && (
                <FeedbackContainer
                  heading={"Reviews"}
                  feedbacks={feedbacks.filter((item) => item.active === true)}
                />
              )}
              {/* Note: Purana <div dangerouslySetInnerHTML> yahan se remove kar diya gaya hai */}
            </Box>
            
            {/* 👇 Description rendering ko Box sx={{ m: 2 }} ke bahar call kiya hai */}
            {renderHomeDescription()} 

          </div>
        ) : (
          <div
            style={{
              display: "flex",
              minHeight: "30vh",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={LoaderImage} height={500} alt="Alt value" />
          </div>
        )}
      </div>
    </>
  );
}

export default HomePage;